import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';

const BottomBannerList = () => {
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const history = useHistory();

  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(
        `https://samaj.aasmo.in/api/admin/sponsors/?page=${currentPage}&search=${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response?.data?.sponsors,"s")
      setCategories(response?.data?.sponsors);
      // Update totalPages based on response if available
      // setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (id) => {
    history.push(`/edit-sponsor/${id}`);
  };

  const handleDelete = async (id) => {
    console.log(id, "id")
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/sponsor/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response) {
        console.log("Deleted Successfully");
        getData();
      }
    } catch (error) {
      console.log(error);
    }
    setShowModal(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id);
    setShowModal(true);
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Sponsors List</h2>
        </div>
        <div className="d-flex justify-content-between">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Category Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Creator</th>
                <th>Title</th>
                <th>Banner Image</th>
                <th>Pincode</th>
                <th>City</th>
                <th>Package Title</th>
                <th>Package Amount</th>
                <th>Status</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category, index) => {
                let statusClass;
                switch (category.status) {
                  case 'no':
                    statusClass = 'text-danger';
                    break;
                  case 'yes':
                  case 'approved':
                    statusClass = 'text-success';
                    break;
                  default:
                    statusClass = 'text-primary';
                }
                const imageUrl = `https://uma-classees.blr1.digitaloceanspaces.com/${category.image}`;
                return (
                  <tr key={category._id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    <td>{category.createdBy ? category.createdBy.name : 'admin'}</td>

                    <td>{category.title}</td>
                    <td>
                      <img src={imageUrl} height="50px" width="60px" className="user-photo" alt="Banner" />
                    </td>
                    <td>{category.pincode}</td>
                    <td>{category.city}</td>
                    <td>{category?.package?.title}</td>
                    <td>{category?.package?.amount}</td>
                    <td className={statusClass}>
                      {category.status === 'no' ? 'Rejected' : category.status === 'yes' || category.status === 'approved' ? 'Approved' : 'Pending'}
                    </td>
                    <td>{formatDate(category.createdAt)}</td>
                    <td>
                      <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
                      &nbsp;&nbsp;
                      <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(BottomBannerList);
